export const events = {
	otpRequested: 'OTP_REQUESTED',
	userLoggedIn: 'USER_LOGGED_IN',
	userLoggedOut: 'USER_LOGGED_OUT',
	profileLoaded: 'PROFILE_LOADED',
};
